<template>
  <div class="thumb-zoom">
    <ul class="thumb">
      <li v-for="(item, index) in thumb" :class="[item.flag === 'true' ? 'cur' : '']" @click="toggleImg(item)" v-if="index < 3">
        <p v-lazy:background-image="item.src"></p>
      </li>
    </ul>
    <div class="thumbZoom">
      <template v-for="item in thumb" v-if="item.flag === 'true'">
        <img :src="item.src">
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: Array,
      path: Boolean
    },
    data () {
      return {
        DATA: this.list,
        thumb: []
      }
    },
    methods: {
      isThumb () {
        if (this.DATA) {
          this.DATA.forEach((arr, index) => {
            this.thumb.push({
              flag: index === 0 ? 'true' : '',
              src: this.path ? this.$store.state.imgUrl + arr : arr
            })
          })
        }
      },
      toggleImg (v) {
        this.thumb.forEach(arr => {
          arr.flag = ''
        })
        v.flag = 'true'
      }
    },
    created () {
      this.isThumb()
    }
  }
</script>

<style lang="less" scoped>
  .thumb-zoom {
    .thumb {
      float: left;
      height: 510px;
      overflow: hidden;
      li {
        width: 160px;
        height: 160px;
        margin-bottom: 12px;
        border: 1px solid #eee;
        background-color: white;
        cursor: pointer;
        position: relative;
        p {
          position: absolute;
          top: 5px;
          right: 5px;
          bottom: 5px;
          left: 5px;
          background-size: cover;
        }
      }
      .cur {
        border: 1px solid #cdad66;
      }
    }
    .thumbZoom {
      float: right;
      width: 508px;
      height: 508px;
      border: 1px solid #eee;
      background-color: white;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/thumb-zoom/index.vue